import { useTranslation } from '~src/i18n/use-translation';
import { formatAmount, fromAPIAmount } from '~src/utils/amount';

interface Props {
  value: number | undefined;
  currency: string | undefined;
}

export function Amount({ value, currency }: Props) {
  const { i18n } = useTranslation();

  if (value === undefined || currency === undefined) {
    return false;
  }

  return formatAmount(fromAPIAmount({ value, currency })!, currency, i18n.resolvedLanguage);
}
